import { render, staticRenderFns } from "./regulationDetail.vue?vue&type=template&id=1620fded&scoped=true&"
import script from "./regulationDetail.vue?vue&type=script&lang=js&"
export * from "./regulationDetail.vue?vue&type=script&lang=js&"
import style0 from "./regulationDetail.vue?vue&type=style&index=0&id=1620fded&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620fded",
  null
  
)

export default component.exports